import { createFromJS } from "../../../types";
import { typeSelectors } from "../../definition/types";
import { itemActionTypes, itemSelectors } from "../../items";
import { actionTypes } from "../actions";
import {
  removeRelationshipColumns,
  removeRelationshipColumnTypeIds,
  removeSubwayThreads,
  removeTimelineGroups
} from "./byId.shared";

const handleItemDeletion = (state, ids) => {
  return removeTimelineGroups(removeSubwayThreads(removeRelationshipColumns(state, ids), ids), ids);
};

const addNewItemToOpenViews = (state, action, prevGlobalState) => {
  const type = typeSelectors.getTypeForId(prevGlobalState, action.itemType);

  if (type.showAsColumn) {
    const existingItemsOfType = itemSelectors
      .getItemsOfType(prevGlobalState, action.itemType)
      .map(i => i.id)
      .toList();

    return state.map(s =>
      s
        .updateIn(["relationshipOptions", "columnIds"], columnIds => columnIds.push(action.id))
        .updateIn(["subwayOptions", "threadIds"], columnIds => {
          // We only want to add the type to subway view if every other item of that type is currently shown
          const showingAllOfType =
            existingItemsOfType.size > 0 && !existingItemsOfType.find(id => columnIds.indexOf(id) < 0);
          return showingAllOfType ? columnIds.push(action.id) : columnIds;
        })
    );
  }
  return state;
};

const byIdModesCrossReducer = (state = createFromJS.AppStateRecord(), action, prevGlobalState) => {
  switch (action.type) {
    //#!if readonly !== true
// case itemActionTypes.DELETE_ITEMS:
// return handleItemDeletion(state, action.ids);
// case itemActionTypes.CREATE_ITEM:
// return addNewItemToOpenViews(state, action, prevGlobalState);
    //#!endif
    case actionTypes.REMOVE_RELATIONSHIP_COLUMN_TYPE_FROM_ALL_VIEWS:
      return removeRelationshipColumnTypeIds(state, action.typeIds);
    case actionTypes.REMOVE_RELATIONSHIP_COLUMNS_FROM_ALL_VIEWS:
      return removeRelationshipColumns(state, action.itemIds);
    case actionTypes.REMOVE_TIMELINE_GROUP_FROM_ALL_VIEWS:
      return removeTimelineGroups(state, action.itemOrTypeIds);
    default:
      return state;
  }
};

export default byIdModesCrossReducer;
